import { StyledPageBottom } from './style';

export const PageBottom = (props) => {
  return <StyledPageBottom>{props.children}</StyledPageBottom>;
}
